/**
 * @notes: reducer reducer
 */

import { IStream } from "model/entities/Job";
import { IAction } from "redux/store/model";
import { insertNewItemToArr, updateErrorsList } from "utils/reducerUtils";

import * as actionCreators from "./actionCreators";
import * as types from "./actionTypes";
import initialState from "./initialState";
import { prepareStreamsForFrontend } from "./utils";

export interface IStreamState {
  isFetchingAll: boolean;
  isCreating: boolean;
  isUpdating: boolean;
  isDeleting: boolean;
  isArchiving: boolean;
  isRestoring: boolean;
  isComputing: boolean;
  isRunning: boolean;
  isFetchingJobHistory: boolean;
  selectedStream: IStream | null;
  streams: IStream[];
  errors: any[];
}

/**
 * Dashboards reducer takes current state and action and returns a new state for the dashboards object in redux store
 * @param state initial state of dashboards
 * @param action Action object dispatched from actions
 * @return {Object} new state or initial state
 * */
export default function reducer(state = initialState, action: IAction) {
  switch (action.type) {
    case types.CREATE_STREAM_BEGIN:
      return {
        ...state,
        isCreating: true,
      };

    case types.CREATE_STREAM_FAILURE:
      return {
        ...state,
        isCreating: false,
        errors: updateErrorsList(state, action),
      };

    case types.CREATE_STREAM_SUCCESS: {
      const { stream } = action as actionCreators.ICreateStreamSuccessAction;

      return {
        ...state,
        isCreating: false,
        streams: insertNewItemToArr(state.streams, stream),
      };
    }

    case types.UPDATE_STREAM_BEGIN:
      return {
        ...state,
        isUpdating: true,
      };

    case types.UPDATE_STREAM_FAILURE:
      return {
        ...state,
        isUpdating: false,
        errors: updateErrorsList(state, action),
      };

    case types.UPDATE_STREAM_SUCCESS: {
      const { stream } = action as actionCreators.IUpdateStreamSuccessAction;

      const streams = state.streams.map((s) =>
        s.id === stream.id ? stream : s,
      );

      return {
        ...state,
        isUpdating: false,
        streams,
      };
    }

    case types.DELETE_STREAM_BEGIN:
      return {
        ...state,
        isDeleting: true,
      };

    case types.DELETE_STREAM_FAILURE: {
      return {
        ...state,
        isDeleting: false,
        errors: updateErrorsList(state, action),
      };
    }

    case types.DELETE_STREAM_SUCCESS: {
      const { id } = action as actionCreators.IDeleteStreamSuccessAction;

      const streams = state.streams.filter((s) => s.id !== id);

      return {
        ...state,
        isDeleting: false,
        streams,
      };
    }

    case types.FETCH_ALL_STREAMS_BEGIN: {
      return {
        ...state,
        isFetchingAll: true,
      };
    }

    case types.FETCH_ALL_STREAMS_FAILURE: {
      return {
        ...state,
        isFetchingAll: false,
        errors: updateErrorsList(state, action),
      };
    }

    case types.FETCH_ALL_STREAMS_SUCCESS: {
      const { streams } = action as actionCreators.IFetchStreamsSuccessAction;
      return {
        ...state,
        isFetchingAll: false,
        streams: prepareStreamsForFrontend(streams),
      };
    }
    case types.RUN_STREAM_JOB_BEGIN:
      return {
        ...state,
        isRunning: true,
      };

    case types.RUN_STREAM_JOB_FAILURE:
      return {
        ...state,
        isRunning: false,
        errors: updateErrorsList(state, action),
      };

    case types.RUN_STREAM_JOB_SUCCESS: {
      return {
        ...state,
        isRunning: false,
      };
    }
    default:
      return state;
  }
}
